// Serves the standalone /partner/ai-assessment.html file (in /public) exactly
// as authored — no navbar, no app chrome, no rewriting. A full-viewport
// iframe keeps the clean URL "/partner/ai-assessment" while the underlying
// HTML/CSS/JS ships byte-for-byte from the static asset.
import React, { useEffect } from "react";

export default function AiAssessment() {
  useEffect(() => {
    const prev = document.title;
    document.title = "SwaanStay — AI Hotel Success Assessment";
    return () => { document.title = prev; };
  }, []);

  return (
    <iframe
      src="/partner/ai-assessment.html"
      title="SwaanStay AI Hotel Success Assessment"
      data-testid="ai-assessment-frame"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: 0,
        margin: 0,
        padding: 0,
        display: "block",
        background: "#fff",
        zIndex: 999999,
      }}
    />
  );
}
